import { useSelector } from "react-redux";
import { Grid } from '@material-ui/core'

export const StatusList = () => {
  const editStatus = useSelector(state => state.entities.dcs.editPaxStatus);
  let addRemark = editStatus.find(obj => obj.type === 'addRemark')
  let addApfax = editStatus.find(obj => obj.type === 'addApfax')
  let editPhone = editStatus.find(obj => obj.type === 'editPhone')
  let editWeight = editStatus.find(obj => obj.type === 'editWeight')
  let dontDisplay = {display: 'none'}
  let display = {fontWeight: 'bold', marginBottom: '8px'}

  const getStatusMsg = (status) => {
    let output = 'test'
    if (status === true) {
      output = 'Success!'
    }
    else if (status === false) {
      output = 'Failure'
    }
    else if (status === null) {
      output = 'Sending...'
    }
    return output
  }

  return (
    <Grid>
      <Grid container item xs={12} style={addRemark.status === '' ? dontDisplay : display}>adding remark: {getStatusMsg(addRemark.status)}</Grid>
      <Grid container item xs={12} style={addApfax.status === '' ? dontDisplay : display}>adding apfax: {getStatusMsg(addApfax.status)}</Grid>
      <Grid container item xs={12} style={editPhone.status === '' ? dontDisplay : display}>editing phone: {getStatusMsg(editPhone.status)}</Grid>
      <Grid container item xs={12} style={editWeight.status === '' ? dontDisplay : display}>editing weight: {getStatusMsg(editWeight.status)}</Grid>
    </Grid>
  )
}

export const factChoices = [
  {label: 'None', value: ''},
  {label: 'AVIH', value: 'AVIH'},
  // NOTE // ERROR PETC REQUIRES ADDITIONAL INFORMATION
  // {label: 'PETC', value: 'PETC'},
  // NOTE // ERROR INFT REQUIRES ADDITIONAL INFORMATION
  // {label: 'INFT', value: 'INFT'},
  // NOTE // ERROR GOLF UNAVAILABLE AS OUT OF SERVICE
  // {label: 'GOLF', value: 'GOLF'},
  {label: 'BIKE', value: 'BIKE'},
  // NOTE // FAX UNSUPPORTED: WCXX
  // {label: 'WCxx', value: 'WCxx'},
  {label: 'HLTH', value: 'HLTH'},
  // NOTE // FAX UNSUPPORTED: VIP
  // {label: 'VIP', value: 'VIP'},
  {label: 'VTST', value: 'VTST'},
  {label: 'CATT', value: 'CATT'},
  {label: 'PVSH', value: 'PVSH'},
]